<template>
	<div class="col-12">
		<span v-for="(pasta, index) in pastas" :key="index">
			<a class="cursor" @click="selectedFolder(pasta.caminho)">{{ pasta.nome }}</a>
			<span>/</span>
		</span>
	</div>
</template>
<script>
export default {
	props: ["pathCurrent"],
	data() {
		return { pastas: [] };
	},
	mounted() {
		this.explodePath();
	},
	methods: {
		selectedFolder(caminho) {
			this.$emit("selected", { caminho: caminho });
		},
		explodePath() {
			const path = require("path");
			var ds = path.sep;

			var caminho = this.pathCurrent.replaceAll("\\", ds);
			caminho = caminho.split(ds + "Membros" + ds);

			if (caminho.length > 0) {
				var pastas = caminho[1].split(ds);
				this.pastas = [];
				for (var i = 0; i < pastas.length; i++) {
					var nomeTemp = pastas[i];
					var nome = nomeTemp.charAt(0).toUpperCase() + nomeTemp.slice(1);
					this.pastas.push({
						nome: nome,
						caminho:
							caminho[0] + ds + "Membros" + ds + this.mountPath(pastas, i, ds) + pastas[i],
					});
				}
			}
		},
		mountPath(pastas, end, ds) {
			var path = "";
			for (var i = 0; i < pastas.length; i++) {
				if (i < end) {
					path += pastas[i] + ds;
				}
			}
			return path;
		},
	},
};
</script>
<style lang="css">
.cursor {
	cursor: pointer;
	color: rgb(76, 151, 212);
}
</style>
